export default function userDirective() {
  return {
    template: require('./release-note.html'),
    restrict: 'E',
    controller: 'ReleaseNoteController',
    controllerAs: 'releaseNoteVM',
    bindToController: true,
    replace: true,
    scope: {
      releaseNote: '=',
      searchText: '=',
    },
  };
}
